import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { odataFetch } from "../../lib/odata-fetch";
import {
  UADMCreateDocument2Params,
  UADMCreateDocumentResponse,
} from "../../odata/appu4dm/AppU4DMModel";
import { QUADMCreateDocument } from "../../odata/appu4dm/QAppU4DM";
import { documentsKeys } from "./documents-keys";

export function useUploadDocument() {
  const queryClient = useQueryClient();
  const { token } = queryClient.getDefaultOptions().queries?.meta ?? {};
  const { mutate, ...mutation } = useMutation({
    mutationFn: (file: File) => uploadDocument(file, token!),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: documentsKeys.getAll() });
    },
  });

  return { uploadDocument: mutate, ...mutation };
}

function _arrayBufferToBase64(buffer: ArrayBuffer) {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

async function uploadDocument(file: File, token: string) {
  const builder = createQueryBuilderV4(
    "UADMCreateDocument",
    new QUADMCreateDocument()
  );

  const buffer = await file.arrayBuffer();
  return odataFetch<UADMCreateDocumentResponse, UADMCreateDocument2Params>({
    method: "POST",
    builder,
    token,
    body: {
      command: {
        DatasetNId: null,
        File: _arrayBufferToBase64(buffer),
        FileName: file.name,
        MIMEType: file.type,
        NId: file.name,
        Type: "Dataset",
      },
    },
  });
}
